const heroCarousel = {
  displayField: 'title',
  name: 'Search Hero Carousel',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'heroCarouselSlides',
      name: 'Hero Carousel Slides',
      type: 'Array',
      localized: false,
      required: true,
      validations: [ { size: { min: 1, max: null } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'heroBgCarouselManualEntry' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentTypeField: {
        heroCarouselSlides: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ]
      }
    }
  },
  sys: {
    id: 'heroCarousel',
    version: 8,
    updatedAt: '2023-08-03T19:43:17.562Z'
  }
};
export default heroCarousel;